import React from 'react';
import styled from 'styled-components';

import { DiscountTag } from 'src/assets/discount-tag';
import { Confetti } from 'src/assets/confetti';
import { ProgressCircle } from 'src/components/progress-circle';

type ProgressProps = {
  progress: number;
  isCompleted?: boolean;
};

export const Progress = ({ progress, isCompleted = false }: ProgressProps): JSX.Element => (
  <Wrapper>
    {isCompleted && (
      <ConfettiWrapper>
        <Confetti />
      </ConfettiWrapper>
    )}

    <ProgressCircle progress={progress} size={38} strokeWidth={4}>
      <DiscountTag width={16} height={16} />
    </ProgressCircle>
  </Wrapper>
);

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex-shrink: 0;
  height: 38px;
  justify-content: center;
  position: relative;
  width: 38px;
`;

const ConfettiWrapper = styled.div`
  animation: 1s confetti-pop ease-out;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);

  @keyframes confetti-pop {
    0% {
      opacity: 0;
      transform: translate(-50%, -50%) scale(0) rotate(-10deg);
    }
    50% {
      transform: translate(-50%, -50%) scale(1.1) rotate(5deg);
    }
    100% {
      opacity: 1;
      transform: translate(-50%, -50%) scale(1) rotate(0deg);
    }
  }

  svg {
    display: block;
  }
`;
